const SCOPE = 'policies';
export default SCOPE;
